import React from 'react';
import { useTranslate } from 'piral-translate';

import './profile-button.css';

const UserIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM5 20c0-3.5 3-6 7-6s7 2.5 7 6H5Z" />
  </svg>
);

export const ProfileButton = ({ keycloak }) => {
  const translate = useTranslate();

  const logout = React.useCallback(() => {
    keycloak.logout({ redirectUri: window.location.origin });
  }, []);

  const version = process.env.BUILD_PCKG_VERSION;
  const name = keycloak.idTokenParsed?.['name'];
  const email = keycloak.idTokenParsed?.['email'];

  return (
    <div className="neo-dropdown-menu neo-profile-button">
      <button type="button"><UserIcon /></button>
      <div className="neo-profile-menu">
        <div className="neo-profile-menu-header">
          <p className="version">v{version}</p>
          <p className="details">{translate('angemeldet-als')}:</p>
          <h3 className="name">{name}</h3>
          <p className="details">{email}</p>
        </div>
        <div>
          <button className="neo-profile-menu-button" onClick={logout} type="button">
            <div className="neo-profile-menu-button-icon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
                />
              </svg>
            </div>
            {translate('abmelden')}
          </button>
        </div>
      </div>
    </div>
  );
};
